import { toast } from "sonner";

interface OpenNotificationParams {
  key?: string;
  message: string;
  type: "success" | "error" | "warning" | "info" | "progress";
  description?: string;
  cancelMutation?: () => void;
  undoableTimeout?: number;
}

export const useNotification = () => {
  const showNotification = ({
    key,
    message,
    type,
    description,
    cancelMutation,
    undoableTimeout,
  }: OpenNotificationParams) => {
    const id = key || Math.random().toString(36).substr(2, 9);

    const actions =
      type === "progress" && cancelMutation
        ? {
            actions: [
              {
                label: "Cancel",
                action: () => {
                  cancelMutation();
                  close(id);
                },
              },
            ],
          }
        : undefined;

    // @ts-expect-error fix build
    toast[type](message, {
      id,
      description,
      closeButton: true,
      ...actions,
      duration: undoableTimeout || 3000,
    });
  };

  const hideNotification = (key: string) => {
    toast.dismiss(key);
  };

  return { showNotification, hideNotification };
};
